import { z } from 'zod';

export const PostSubmitEddQuestionsResultSchema = z.object({
  code: z.number(),
});

export type PostSubmitEddQuestionsResult = z.infer<
  typeof PostSubmitEddQuestionsResultSchema
>;

export interface PostSubmitEddQuestionsParams {
  edd_questions: [
    {
      question_id: string;
      answers: Array<{ id?: string; value?: string }>;
    },
    {
      question_id: string;
      answers: Array<{ id?: string; value?: string }>;
    },
    {
      question_id: string;
      answers: Array<{ id?: string; value?: string }>;
    },
    {
      question_id: string;
      answers: Array<Array<{ id?: string; value?: string }>>;
    },
    {
      question_id: string;
      answers: Array<{ id?: string; value?: string }>;
    },
    {
      question_id: string;
      answers: Array<{ id?: string; value?: string }>;
    },
    {
      question_id: string;
      answers: Array<{ id?: string; value?: string }>;
    },
  ];
}
